// extracted by mini-css-extract-plugin
export var compact = "_n7-2";
export var phoneFrame = "_n7-0";
export var phoneScreen = "_n7-1";